/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateLeadCareAttributesRequest
 */
export interface UpdateLeadCareAttributesRequest {
    /**
     * 
     */
    lead_id: string;
    /**
     * 
     */
    category: UpdateLeadCareAttributesRequestCategoryEnum;
    /**
     * 
     */
    care_attribute_ids: Array<string>;
}


/**
 * @export
 */
export const UpdateLeadCareAttributesRequestCategoryEnum = {
    ClinicalCareNeed: 'clinical_care_need',
    Program: 'program',
    TypeOfCare: 'type_of_care',
} as const;
export type UpdateLeadCareAttributesRequestCategoryEnum = typeof UpdateLeadCareAttributesRequestCategoryEnum[keyof typeof UpdateLeadCareAttributesRequestCategoryEnum];


/**
 * Check if a given object implements the UpdateLeadCareAttributesRequest interface.
 */
export function instanceOfUpdateLeadCareAttributesRequest(value: object): value is UpdateLeadCareAttributesRequest {
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('care_attribute_ids' in value) || value['care_attribute_ids'] === undefined) return false;
    return true;
}

export function UpdateLeadCareAttributesRequestFromJSON(json: any): UpdateLeadCareAttributesRequest {
    return UpdateLeadCareAttributesRequestFromJSONTyped(json, false);
}

export function UpdateLeadCareAttributesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeadCareAttributesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'lead_id': json['lead_id'],
        'category': json['category'],
        'care_attribute_ids': json['care_attribute_ids'],
    };
}

export function UpdateLeadCareAttributesRequestToJSON(json: any): UpdateLeadCareAttributesRequest {
    return UpdateLeadCareAttributesRequestToJSONTyped(json, false);
}

export function UpdateLeadCareAttributesRequestToJSONTyped(value?: UpdateLeadCareAttributesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lead_id': value['lead_id'],
        'category': value['category'],
        'care_attribute_ids': value['care_attribute_ids'],
    };
}

